import React, { useEffect, useState } from "react";
import { GrFormPrevious } from "react-icons/gr";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { IoCopyOutline } from "react-icons/io5";
import { toast } from "react-toastify";

export default function UserViewComponent({ user, onBack }) {
  const handleCopy = () => {
    navigator.clipboard.writeText(
      `(${
        user.countryCode?.includes("+")
          ? user.countryCode
          : `+${user.countryCode}`
      }) ${user.phone}`
    );
    toast.success("Number copied to clipboard!");
  };
  return (
    <section className="">
      {/* Header */}
      <div className="sticky top-0 z-10 border-l border-[#EBEBEB] w-full min-h-[80px] bg-white flex items-center justify-between border-b text-black p-4">
        <div className="flex items-center gap-4">
          <GrFormPrevious
            onClick={onBack} // 👈 back to contact info
            className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1 border rounded-md"
          />
          <h1 className="text-lg font-semibold"> Contact Info</h1>
        </div>
      </div>

      <div className="bg-[#f9f6fe] justify-center h-[calc(100vh-80px)] min-h-[calc(100vh-80px)] max-h-[calc(100vh-80px)] gap-2 overflow-y-auto overflow-x-hidden">
        <div className="bg-white pb-4 rounded-b-lg">
          <div className="profile-section p-4 pt-6 rounded-xl max-w-md flex flex-col justify-center items-center text-center gap-4">
            <div className="avatar">
              <div className="w-[160px] h-[160px] rounded-full">
                <img
                  src={user?.userImage || user?.avtarImage}
                  alt="Emily Rose"
                />
              </div>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-black pt-1 truncate max-w-xs">
                {user.name || "User"}
              </h2>
              <div className="flex pt-2 items-center gap-2 text-sm text-base-content opacity-70">
                <span className="text-black font-normal">
                  (
                  {user?.countryCode?.includes("+")
                    ? user?.countryCode
                    : `+${user?.countryCode}`}
                  ) {user.phone}
                </span>
                <button onClick={handleCopy} className="hover:text-primary">
                  <IoCopyOutline className="text-[var(--primary-color)] font-bold w-5 h-5 " />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="my-1 bg-white pb-4 rounded-lg p-4">
          <h3 className="text-sm font-normal text-[#7C7C7C] mb-1">About</h3>
          <p className="text-[15px] text-black font-semibold">{user.about}</p>
        </div>
        <div className="my-1 bg-white pb-4 py-6 rounded-lg p-4 space-y-5">
          <div className="flex justify-between items-center">
            <div className="cursor-pointer">
              <p className="text-[15px] flex items-center gap-2 text-[#F44336] font-semibold hover:opacity-55">
                <IoMdInformationCircleOutline className="text-xl text-[#F44336]" />
                Report User
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
